<template>
	<div class="table-stat">
		<el-tabs v-model="activeName" @tab-click="handleClick" stretch style="margin-bottom: 20px;">
			<el-tab-pane label="课题类别统计" name="first">
				<el-table id="firstTable" :header-cell-style="tableStyle" border :data="topicTypeList" style="width: 100%">
					<el-table-column :label="item.name" :prop="item.children ? '' : item.name" v-for="(item, index) in topicTypeTableData" :key="index">
						<template v-if="item.children">
							<el-table-column :prop="item1.key" :label="item1.name" v-for="(item1, index1) in item.children" :key="index1"></el-table-column>
						</template>
					</el-table-column>
				</el-table>
			</el-tab-pane>
			<el-tab-pane label="课题领域统计" name="second">
				<el-table id="secondTable" :header-cell-style="tableStyle" border :data="topicDomainList" style="width: 100%">
					<el-table-column :label="item.name" :prop="item.children ? '' : item.name" v-for="(item, index) in topicDomainTableData" :key="index">
						<template v-if="item.children">
							<el-table-column :prop="item1.key" :label="item1.name" v-for="(item1, index1) in item.children" :key="index1"></el-table-column>
						</template>
					</el-table-column>
				</el-table>
			</el-tab-pane>
			
			<el-tab-pane label="按学段统计" name="third">
				<el-table id="thirdTable" :header-cell-style="tableStyle" border :data="studyPhaseList" style="width: 100%">
					<el-table-column :label="item.name" :prop="item.children ? '' : item.name" v-for="(item, index) in studyPhaseTableData" :key="index">
						<template v-if="item.children">
							<el-table-column :prop="item1.key" :label="item1.name" v-for="(item1, index1) in item.children" :key="index1"></el-table-column>
						</template>
					</el-table-column>
				</el-table>
			</el-tab-pane>
			
			<el-tab-pane label="研究阶段统计" name="fourth">
				<el-table id="fourthTable" :header-cell-style="tableStyle" border :data="researchPhaseList" style="width: 100%">
					
					<el-table-column :label="item.name" :prop="item.children ? '' : item.name" v-for="(item, index) in researchPhaseTableData" :key="index">
						<template v-if="item.children">
							<el-table-column :prop="item1.key" :label="item1.name" v-for="(item1, index1) in item.children" :key="index1"></el-table-column>
						</template>
					</el-table-column>
					
				</el-table>
			</el-tab-pane>
			
			<el-tab-pane label="按学科统计" name="fifth">
				<el-table id="fifthTable" :header-cell-style="tableStyle" border :data="disciplinePhaseList" style="width: 100%">
					
					
					<el-table-column :label="item.name" :prop="item.children ? '' : item.name" v-for="(item, index) in disciplinePhaseTableData" :key="index">
						<template v-if="item.children">
							<el-table-column :prop="item1.key" :label="item1.name" v-for="(item1, index1) in item.children" :key="index1"></el-table-column>
						</template>
					</el-table-column>
					
				</el-table>
			</el-tab-pane>
			<el-tab-pane label="按学校统计" name="sixth">
				<el-form :inline="true" ref="schoolStatFormRef" :model="schoolStatForm" label-width="80px">
				  <el-form-item label="区域名称">
				    <el-input v-model="schoolStatForm.name"></el-input>
				  </el-form-item>
					<el-button type="primary" @click="search">查询</el-button>
				</el-form>
				<el-table id="sixthTable" :header-cell-style="tableStyle" border :data="schoolList" style="width: 100%">
					
					<el-table-column :label="item.name" :prop="item.children ? '' : item.name" v-for="(item, index) in schoolTableData" :key="index">
						<template v-if="item.children">
							<el-table-column :prop="item1.key" :label="item1.name" v-for="(item1, index1) in item.children" :key="index1"></el-table-column>
						</template>
					</el-table-column>
					
				</el-table>
			</el-tab-pane>
		</el-tabs>
		<div class="btn_wrap">
			<el-button type="primary" @click="exportExcel">导出Excel</el-button>
			<el-button type="primary" @click="goBack">返回</el-button>
		</div>
	</div>
</template>

<script>
import { getTopicTypeTable, getTopicDomainTable,getResearchPhaseTable, getStudyPhaseTable, getDisciplineTable, getSchoolTable } from '@/api/after/topicManage.js';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
	props: {
		showIndex: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			tableStyle: {
				backgroundColor: '#5172c5',
				textAlign: 'center',
				color: '#fff'
			},
			activeName: 'first',

			topicTypeTableData: [], //课题类型表格表头数据
			topicTypeList: [], //课题类型表格数据

			topicDomainTableData: [], //课题领域表头数据
			topicDomainList: [], //课题领域表格数据
			
			researchPhaseTableData: [], //研究阶段表头数据
			researchPhaseList: [], //研究阶段表格数据
			
			studyPhaseTableData: [], //学段表头数据
			studyPhaseList: [], //学段表格数据
			
			disciplinePhaseTableData: [], //学科表头数据
			disciplinePhaseList: [], //学科
			
			schoolStatForm:{
				name:'',
			},
			schoolTableData: [],//学校表头数据
			schoolList: [],//学校数据
		};
	},
	created() {
		this.getTopicTypeTable();
		this.getTopicDomainTable()
		this.getResearchPhaseTable()
		this.getStudyPhaseTable()
		this.getDisciplineTable()
		this.getSchoolTable()
		this.getActiveName()
	},
	methods: {
		
		search(){
			this.getSchoolTable(this.schoolStatForm.name)
		},
		// 处理数组数据获取一个表格新对象
		disposeData(arr){
			// 获取一个对象中所有的key值
			let keys = Object.keys(arr[0]);
			let newObj = {};
			// 初始化新对象的数据
			keys.forEach(item => {
				if (item === '立项年度') {
					newObj[item] = '合计';
				} else {
					newObj[item] = 0;
				}
			});
			// 循环计算新对象中的数据
			arr.forEach((item, index) => {
				for (let item1 in item) {
					if (item1 === '立项年度') {
						continue;
					}
					newObj[item1] += item[item1];
				}
			});
			return newObj
		},
		// 课题类别表格
		async getTopicTypeTable() {
			const res = await getTopicTypeTable();
			if (res.code == 200) {
				console.log('课题类别表格', res);
				this.topicTypeTableData = res.data.table;
				if (res.data.dateMap.length) {
					let newObj = this.disposeData(res.data.dateMap)
					console.log('处理后的数据', newObj);
					this.topicTypeList = res.data.dateMap.concat(newObj);
				}
			} else {
				this.$message.error(res.data);
			}
		},
		// 课题领域表格
		async getTopicDomainTable(){
			const res = await getTopicDomainTable()
			if (res.code == 200) {
				console.log('课题领域',res);
				this.topicDomainTableData = res.data.table
				if (res.data.dateMap.length) {
					let newObj = this.disposeData(res.data.dateMap)
					console.log('处理后的数据', newObj);
					this.topicDomainList = res.data.dateMap.concat(newObj)
				}
			}else{
				this.$message.error(res.data)
			}
		},
		// 课题研究阶段表格
		async getResearchPhaseTable(){
			const res = await getResearchPhaseTable()
			if (res.code == 200) {
				console.log('课题研究阶段',res);
				this.researchPhaseTableData = res.data.table
				if (res.data.dateMap.length) {
					let newObj = this.disposeData(res.data.dateMap)
					console.log('处理后的数据', newObj);
					this.researchPhaseList = res.data.dateMap.concat(newObj)
				}
			}else{
				this.$message.error(res.data)
			}
		},
		// 课题学段表格
		async getStudyPhaseTable(){
			const res = await getStudyPhaseTable()
			if (res.code == 200) {
				console.log('课题学段',res);
				this.studyPhaseTableData = res.data.table
				if (res.data.dateMap.length) {
					let newObj = this.disposeData(res.data.dateMap)
					console.log('处理后的数据', newObj);
					this.studyPhaseList = res.data.dateMap.concat(newObj)
				}
			}else{
				this.$message.error(res.data)
			}
		},
		// 学科表格
		async getDisciplineTable(){
			const res = await getDisciplineTable()
			if (res.code == 200) {
				console.log('学科',res);
				this.disciplinePhaseTableData = res.data.table
				if (res.data.dateMap.length) {
					let newObj = this.disposeData(res.data.dateMap)
					console.log('处理后的数据', newObj);
					this.disciplinePhaseList = res.data.dateMap.concat(newObj)
				}
			}else{
				this.$message.error(res.data)
			}
		},
		// 学校表格
		async getSchoolTable(name){
			const res = await getSchoolTable(name)
			if (res.code == 200) {
				console.log('学校',res);
				this.schoolTableData = res.data.table
				if (res.data.dateMap.length) {
					// 处理数据获取横向总计数据
					let newObj = {}
					let keys = Object.keys(res.data.dateMap[0])
					console.log('学校对象数据',keys);
					// 初始化对象中的所有数据
					keys.forEach(item=>{
						if (item === '序号') {
							newObj[item] = res.data.dateMap.length + 1
						}else if (item === '学校名称') {
							newObj[item] = '合计'
						}else{
							newObj[item] = 0
						}
					})
					console.log('学校初始化数据',newObj);
					// 循环计算数据
					res.data.dateMap.forEach(item=>{
						for(let item1 in item){
							if (item1 === '学校名称') {
								continue
							}
							if (item1 === '序号') {
								continue
							}
							newObj[item1] += item[item1]
						}
					})
					
					this.schoolList = res.data.dateMap.concat(newObj)
				}else{
					this.schoolList = []
				}
			}else{
				this.$message.error(res.data)
			}
		},
		// 导出Excel
		exportExcel(){
			console.log('当前活动',this.activeName);
			let tableId,fileName;
			switch(this.activeName){
				case 'first':
					tableId = 'firstTable'
					fileName = '课题类别统计.xlsx'
					break
				case 'second':
					tableId = 'secondTable'
					fileName = '课题领域统计.xlsx'
					break
				case 'third':
					tableId = 'thirdTable'
					fileName = '按学段统计.xlsx'
					break
				case 'fourth':
					tableId = 'fourthTable'
					fileName = '研究阶段统计.xlsx'
					break
				case 'fifth':
					tableId = 'fifthTable'
					fileName = '按学科统计.xlsx'
					break
				case 'sixth':
					tableId = 'sixthTable'
					fileName = '按学校统计.xlsx'
					break
				default:
					break;
			}
			var xlsxParam = { raw: true };
			var wb = XLSX.utils.table_to_book(document.querySelector('#'+tableId), xlsxParam);
			var wbout = XLSX.write(wb, {
				bookType: 'xlsx',
				bookSST: true,
				type: 'array'
			});
			try {
				FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), fileName);
			} catch (e) {
				if (typeof console !== 'undefined') {
					console.log(e, wbout);
				}
			}
			return wbout;
		},
		handleClick(tab, event) {
			console.log('tab切换', tab, event);
		},
		goBack() {
			this.$emit('goBack');
		},
		// 判断表格页面该显示那个表格
		getActiveName(){
			switch (this.showIndex) {
				case 0:
					this.activeName = 'first';
					break;
				case 1:
					this.activeName = 'second';
					break;
				case 2:
					this.activeName = 'third';
					break;
				case 3:
					this.activeName = 'fourth';
					break;
				case 4:
					this.activeName = 'fifth';
					break;
				case 5:
					this.activeName = 'sixth';
					break;
				default:
					break;
			}
		},
	}
};
</script>

<style scoped lang="scss">
.btn_wrap {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
</style>
